
import { NewCropCyclePeriodFilter } from 'src/app/core/models/period-selector/newCropCyclePeriodFilter';
import { NewPeriodSelectorInterval } from 'src/app/core/enums/newPeriodSelectorInterval';
import { NewCropCyclePeriodSelectorItem } from './base/new-crop-cycle-period-selector-item';


export class ToDatePeriodSelectorItem extends NewCropCyclePeriodSelectorItem {
    interval = NewPeriodSelectorInterval.ToDate;
    hasNavigation = true;

    constructor(name: string) {
        super(name);
    }

    getPeriodFilter = () => {
        const periodFilter = new NewCropCyclePeriodFilter();
        periodFilter.periodInterval = NewPeriodSelectorInterval.ToDate;
        periodFilter.intervalLength = 1;
        return periodFilter;
    }
}